







// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (Chatbot: any) => {
	return class Stoicism_Bot extends Chatbot {
		readonly name = 'Stoicism Bot';
		readonly avatar = 'stoicism-bot';
		readonly description = "Listening to this bot is the beginning of all wisdom.";
		
		async getContent() {
			const request = await fetch('https://stoicquotesapi.com/v1/api/quotes/random', {
				headers: {
					Accept: 'application/json'
				}
			})
			const data = await request.json();
			return data.body;
		}
	}
}
